import React from "react";
import { IFrameBlock as IFrameBlockType } from "../../types/optimizely/blocks";

type IFrameBlockProps = IFrameBlockType;

const IFrameBlock = ({ iFrameUrl, height, fullWidth }: IFrameBlockProps) => {
  const url = iFrameUrl?.value;

  if (!url) {
    return null;
  }

  const isFullWidth = fullWidth?.value === true;

  return (
    <div className={isFullWidth ? "w-full" : "container"}>
      <iframe
        src={url}
        style={{ height: height?.value || "600px" }}
        className="w-full border-0"
        title="iframe"
      />
    </div>
  );
};

export default IFrameBlock;
